import React from "react";
import ReactDOM from "react-dom";
import styles from "./JoinGatePrompt.module.scss";

interface JoinGatePromptProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigateToSettings: () => void;
}

const JoinGatePrompt: React.FC<JoinGatePromptProps> = ({ isOpen, onClose, onNavigateToSettings }) => {
  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.card} onClick={(e) => e.stopPropagation()}>
        <button className={styles.closeBtn} onClick={onClose} aria-label="Close">
          ×
        </button>

        <div className={styles.content}>
          <div className={styles.icon}>🔗</div>
          <h3 className={styles.title}>Discord Required</h3>
          <p className={styles.message}>
            Lobbies use Discord voice channels for communication during matches.
            Link your Discord account to join.
          </p>

          <div className={styles.actions}>
            <button className={styles.linkButton} onClick={onNavigateToSettings}>
              Link Discord
            </button>
            <button className={styles.dismissButton} onClick={onClose}>
              Not Now
            </button>
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default JoinGatePrompt;
